var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcAlertError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM13.9896 11.8683C13.4038 11.2825 12.4541 11.2825 11.8683 11.8683C11.2825 12.4541 11.2825 13.4038 11.8683 13.9896L17.8787 20L11.8683 26.0104C11.2825 26.5962 11.2825 27.546 11.8683 28.1318C12.4541 28.7175 13.4038 28.7175 13.9896 28.1318L20 22.1213L26.0104 28.1318C26.5962 28.7175 27.546 28.7175 28.1318 28.1318C28.7175 27.546 28.7175 26.5962 28.1318 26.0104L22.1213 20L28.1318 13.9896C28.7175 13.4038 28.7175 12.4541 28.1318 11.8683C27.546 11.2825 26.5962 11.2825 26.0104 11.8683L20 17.8787L13.9896 11.8683Z",
    fill: "red"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertError);
export default __webpack_public_path__ + "static/media/ic_alert_error.bf6d65a1c5de16a87ee128031952ecc2.svg";
export { ForwardRef as ReactComponent };